"use client";
import React, { lazy, Suspense, useState, useRef, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getAllVenues } from "../../api/venue-api";
import ResponsiveAppBar from "../../components/ResponsiveAppBar";
import NavbarCustomer from "../../components/NavbarCustomer";

import Hero from "./Hero";
import Spaces from "./Spaces";

const ExploreHotel = lazy(() => import("./ExploreHotel"));
const HowWorks = lazy(() => import("./HowWorks"));
const WhyUs = lazy(() => import("./WhyUs"));
const ExploreVenues = lazy(() => import("./ExploreVenues"));
const UniqueSpace = lazy(() => import("./UniqueSpace"));
const ListVenu = lazy(() => import("./ListVenu"));
const Blogs = lazy(() => import("./Blogs"));
const Footer = lazy(() => import("../../components/webComps/Footer"));

const SectionSkeleton = () => (
	<div className="w-[90%] mx-auto my-10 h-64 rounded-xl animate-pulse bg-gray-100" />
);

const Home = ({ filters, setFilters }) => {
	const [customer, setCustomer] = useState(null);
	const customerId = customer?._id || null;
	const [venueFilter, setVenueFilter] = useState([]);
	const heroAfterRef = useRef(null);

	const scrollToHeroAfter = () => {
		heroAfterRef.current?.scrollIntoView({ behavior: "smooth" });
	};

	const { data: venueData } = useQuery({
		queryKey: ["venueData", 1, 1],
		queryFn: () => getAllVenues(1, 1),
		staleTime: 5 * 60 * 1000,
		refetchOnWindowFocus: false,
	});

	useEffect(() => {
		if (venueData) {
			setVenueFilter(venueData.filter((item) => item.category === "Venue"));
		}
	}, [venueData]);

	useEffect(() => {
		setCustomer(JSON.parse(localStorage.getItem("authUser")));
		const handler = () =>
			setCustomer(JSON.parse(localStorage.getItem("authUser")));
		window.addEventListener("storage", handler);
		return () => window.removeEventListener("storage", handler);
	}, []);

	return (
		<div className="overflow-hidden">
			{!customerId ? (
				<div className="z-[999]">
					<ResponsiveAppBar filters={filters} setFilters={setFilters} />
				</div>
			) : (
				<div className="z-[9999]">
					<NavbarCustomer filters={filters} setFilters={setFilters} />
				</div>
			)}

			<div ref={heroAfterRef}>
				<Hero filters={filters} setFilters={setFilters} />
			</div>

			<Spaces />

			<Suspense fallback={<SectionSkeleton />}>
				<HowWorks />
				<WhyUs />
				<ExploreVenues venues={venueFilter} setFilters={setFilters} />
				<UniqueSpace />
			</Suspense>

			<Suspense fallback={<SectionSkeleton />}>
				<ExploreHotel />
			</Suspense>

			<Suspense fallback={<SectionSkeleton />}>
				<ListVenu />
				<Blogs />
				<Footer onScrollDownClick={scrollToHeroAfter} />
			</Suspense>
		</div>
	);
};

export default Home;
